import { render, staticRenderFns } from "./StatusTransition.vue?vue&type=template&id=1940a358&"
import script from "./StatusTransition.vue?vue&type=script&lang=js&"
export * from "./StatusTransition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports